import React from 'react';
export function MegaphoneIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.453 1.515a.5.5 0 01.81.189l5.484 14.62a.5.5 0 01-.468.676H8.65l1.204 4.492-2.898.777L5.545 17H1.5L1 15.133 15.453 1.515zm-.27 3.003L13.44 6.16 16.697 15h2.417l-3.93-10.482zM4.058 15l7.8-7.35L14.566 15H4.058z"
  }));
}